import React, { useState, useRef } from "react";
import Grid from "@mui/material/Grid";
import countryList from "react-select-country-list";
import { Typography, Select, MenuItem, FormControl}from "@mui/material";
import Box from "@mui/material/Box";
import styles from "./styles";
import CustomInput from "../../components/CustomInput";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useForm } from "../../hooks/useForm";
import { CompanyInfoValidate } from "../../helper/Validation";
import { companyInfoData } from "../../constants/data";
import OutlinedInput from "@mui/material/OutlinedInput";
import { LoadingButton } from "@mui/lab";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css"

const CompanyInfoPage = ({handleCompany,loading, industryList}) => {
  const [cCode, setCCode] = useState("")
  const [mobile, setMobile] = useState("")
  const mobileNumberRef = useRef(null);
  const options = countryList().getData();

  const handleCompanyInfo =  (data ) => {
    handleCompany(data, cCode,mobile);
  }

  const handleOnChanges = (value, country) => {
    setMobile(value);
    setCCode(country?.dialCode)
  };

  const {state, handleChange, handleSubmit, handleFocus, disable } = useForm(
    companyInfoData,
    CompanyInfoValidate,
    handleCompanyInfo,
  );

  const { companyName, owner, email, states, city, country, zipCode, industry } = state;

  return (
    <>
      <Box sx={styles.formMain}>
        <Grid container sx={styles.gridContainer}>
          <Grid item xs={12} sm={12} md={6} sx={styles.formGridItem}>
            <Box sx={styles.formContain}>
              <Typography  sx={styles.mainheading}>Company Information</Typography>
              <Typography sx={styles.greyText}>Enter your details below, after that you can continue to your dashboard.</Typography>
              <Box sx={styles.formSection}>
                <form onSubmit={handleSubmit} autoComplete="off">
                  <Box sx={styles.formfields}>
                    <Box sx={styles.flexInput}>
                      <Typography sx={styles.inputText}>Company Name</Typography>
                      <CustomInput
                        name="companyName"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={companyName?.error}
                        value={companyName?.value}
                        placeholder="Company Name"
                      />
                    </Box>
                    <Box sx={styles.flexInput}>
                      <Typography sx={styles.inputText}>Owner</Typography>
                      <CustomInput
                        name="owner"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={owner?.error}
                        value={owner?.value}
                        placeholder="Owner Name"
                      />
                    </Box>
                  </Box>
                  <Box sx={styles.formfields}>
                    <Box sx={styles.flexInput}>
                      <Typography sx={styles.inputText}>Company Mailing Address</Typography>
                      <CustomInput
                        name="email"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={email?.error}
                        value={email?.value}
                        placeholder="Company Email Address"
                      />
                    </Box>
                    <Box sx={styles.flexInput}>
                      <FormControl fullWidth sx={styles.mobileGrid} >
                        <Typography  sx={styles.inputText}>Phone Number </Typography>
                        <PhoneInput
                          country={"za"}
                          enableSearch={true}
                          value={mobile}
                          defaultValue={cCode}
                          name="mobile"
                          onChange={(value, country) => handleOnChanges(value, country)}
                          onFocus={handleFocus}
                          ref={mobileNumberRef} 
                          error={mobile.error}
                          sx={styles.mobile}
                          inputProps={{
                            style: {
                              height: "1em",
                              borderRadius: "10px",
                            },
                            placeholder: "Enter phone number"
                          }}
                        />
                      </FormControl>
                    </Box>
                  </Box>
                  <Box sx={styles.formfields}>
                    <Box sx={styles.flexInput}>
                      <CustomInput
                        name="city"
                        placeholder="City"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={city?.error}
                        value={city?.value}
                      />
                    </Box>
                    <Box sx={styles.flexInput}>
                      <CustomInput
                        name="states"
                        placeholder="State"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={states?.error}
                        value={states?.value}
                      />
                    </Box>
                  </Box>
                  <Box sx={styles.formfields}>
                    <Box sx={styles.flexInput}>
                      <CustomInput
                        name="zipCode"
                        placeholder="Zip Code"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={zipCode?.error}
                        value={zipCode?.value}
                      />
                    </Box>
                    <Box sx={styles.flexInput}>
                      <FormControl fullWidth sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.9em",
                          marginTop: "0.5em",
                          borderRadius: "9px"
                        }
                      }} >

                        <Select
                          value={country.value}
                          onChange={(event) => { handleChange("country", event.target.value) }}
                          name="country"
                          sx={{
                            ...styles.dropDownMenu,
                            color: country.value ? "black" : "rgb(209 209 209)",
                          }}
                          onFocus={handleFocus}
                          error={country.error}
                          displayEmpty
                          input={<OutlinedInput />}
                        >
                          <MenuItem disabled value="" sx={styles.menuPlaceholder}>
                            Country
                          </MenuItem>
                          {options.map((country, index) => (

                            <MenuItem key={index} sx={styles.dropDownMenus} value={country.label}>{country.label}</MenuItem>
                          ))}

                        </Select>
                      </FormControl>
                    </Box>
                  </Box>
                  <Box sx={styles.flexInputs}>
                    <FormControl fullWidth sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "3.3em",
                        marginTop: "0.5em",
                        borderRadius: "10px",
                        textAlign: "left"
                      }
                    }} >

                      <Typography sx={styles.inputText}>Industry</Typography>

                      <Select
                        name="industry"
                        value={industry?.value}
                        onChange={(e) =>handleChange("industry",e.target.value)}
                        onFocus={handleFocus}
                        error={industry?.error}
                        input={<OutlinedInput />}
                        sx={{
                          ...styles.dropDownMenu,
                          color: country.value ? "black" : "rgb(209 209 209)",
                        }}
                        displayEmpty
                        inputProps={{ placeholder: "Select Industry" }}
                      >
                        <MenuItem disabled value="" sx={styles.menuPlaceholder}>
                          Select</MenuItem>

                        {industryList.map((item, index) =>
                          <MenuItem key={index} value={item?.name} sx={styles.dropDownMenus}> {item?.name }
                          </MenuItem>

                        )}

                      </Select>
                    </FormControl>
                  </Box>
                  <LoadingButton
                    loading={loading}
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={disable}
                    sx={styles.submit}
                  >
                    Continue <ChevronRightIcon />
                  </LoadingButton>
                </form>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default CompanyInfoPage;